import { render, staticRenderFns } from "./OrderForecastDispatch.vue?vue&type=template&id=56175428"
import script from "./OrderForecastDispatch.vue?vue&type=script&lang=js"
export * from "./OrderForecastDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports